import React from 'react';
import { HeartHandshakeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-dark pb-32 pt-12 text-center" data-id="element-180" data-mp="2082kbaoisogp">
      <div className="mx-auto max-w-3xl px-5" data-id="element-181" data-mp="209ndowz3m1cz">
        <div className="flex items-center justify-center gap-2.5" data-id="element-182" data-mp="2f53f5n20czje">
          <span className="grid h-9 w-9 place-items-center rounded-xl bg-white/10 text-white" data-id="element-183" data-mp="2a5qrj03bbofr">
            <HeartHandshakeIcon className="h-5 w-5" aria-hidden="true" data-id="element-184" data-mp="1mg5vbfi5euoj" />
          </span>
          <span className="font-display text-xl font-bold text-white" data-id="element-185" data-mp="1mdtg3a3ryyf6">Calm Response 5™</span>
        </div>
        <p className="mt-4 text-sm text-white/70" data-id="element-186" data-mp="1hf8f38gp8apo">© 2026 · Laura Mendes — Creator of Calm Response 5™. All Rights Reserved.</p>
        <p className="mt-6 text-xs leading-relaxed text-white/60" data-id="element-187" data-mp="1rephnh0nm8hf">
          <strong className="text-white/80" data-id="element-188" data-mp="1rdedvh77l0qb">Educational Disclaimer:</strong> Calm Response 5™ is an educational resource. It is not medical, psychological,
          behavioral or therapeutic treatment and does not diagnose, treat or cure autism, ADHD or any other condition. It does not replace
          individualized professional care.
        </p>
      </div>
    </footer>;
}